import { xml2ast, paragraphHtmlParsers, simpleHtmlParsers } from '@utils/ast';
import { decodeHtmlEntities } from '@utils/common';
import { configRefs } from '@utils/constants';
import { parseCaption, parseCaptionDisplayMode } from './util.parse-caption.js';
import { parsePm2Data } from './util.parse-pm2-data.js';

function parseIframeComponentCore(node) {
  const caption = parseCaption(node);
  const pm2 = parsePm2Data(node, caption);
  if (!pm2) {
    return null;
  }
  return {
    nodeType: "iframe-component",
    id: node.getAttribute("id") ?? void 0,
    pm2,
    meta: {
      caption,
      richTextDescription: xml2ast(
        decodeHtmlEntities(node.getAttribute("richTextDescription") ?? "") || decodeHtmlEntities(node.getAttribute("harmonicaDescription") ?? "") || "",
        {
          ...simpleHtmlParsers,
          ...paragraphHtmlParsers
        },
        "text/html"
      ),
      lightboxDescription: xml2ast(
        decodeHtmlEntities(node.getAttribute("lightboxDescription") ?? ""),
        {
          ...simpleHtmlParsers,
          ...paragraphHtmlParsers
        },
        "text/html"
      ),
      previewImage: node.getAttribute("previewImage") ? `${configRefs.apis.pm2.media.dangerouslyAssertSyncValue()}/${node.getAttribute(
        "previewImage"
      )}` : void 0,
      indexOrLevel: node.getAttribute("indexOrLevel") || void 0
    },
    options: {
      autoActivate: node.getAttribute("autoActivate") === "true",
      displayTitle: node.getAttribute("titleOnTop") === "true" ? "above" : "below",
      displayCaption: parseCaptionDisplayMode(node),
      desiredDisplayMode: node.getAttribute("showAsHarmonica") === "true" ? "harmonica" : "embed",
      target: node.getAttribute("openAs") === "new-window" ? "_blank" : void 0,
      monorepo__openAsLightbox: node.getAttribute("openAs") === "lightbox"
    }
  };
}
function extractProportions(proportions, fallback) {
  if (!proportions) {
    return fallback;
  }
  const proportionParts = proportions.split("-");
  const widthStr = proportionParts.shift();
  const heightStr = proportionParts.shift();
  return {
    width: widthStr ? parseInt(widthStr, 10) || fallback.width : fallback.width,
    height: heightStr ? parseInt(heightStr, 10) || fallback.height : fallback.height
  };
}

export { extractProportions, parseIframeComponentCore };
//# sourceMappingURL=component.iframe.core.js.map
